/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  SAVE_FILTER,
  SAVE_FILTER_SUCCESS,
  SAVE_FILTER_FAILURE
} from "../actions/auth/authActionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse
} from "./reducerUtils";

const initialState = {
  data: null,
  state: "INIT",
  error: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SAVE_FILTER:
      return setLoadingState(state);

    case SAVE_FILTER_SUCCESS:
      return setSuccessResponse(state, action);

    case SAVE_FILTER_FAILURE:
      return setErrorResponse(state, action);
    default:
      return state;
  }
}
